/* global $ */

$('body')
  .find('.image-slider')
  .slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

$('body')
  .find('.grid-slider')
  .slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  });

$('body')
  .find('.news-slider')
  .slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow:
      '<div class="next-arrow"><svg class="button-arrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 138.91 25.35"><title>button-arrow</title><polygon class="cls-1" points="0 8.68 124 8.68 124 0 138.91 12.68 124 25.35 124 16.68 0 16.68 0 8.68"/></svg></div>',
    prevArrow:
      '<div class="prev-arrow"><svg class="button-arrow" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 138.91 25.35"><title>button-arrow</title><polygon class="cls-1" points="0 8.68 124 8.68 124 0 138.91 12.68 124 25.35 124 16.68 0 16.68 0 8.68"/></svg></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          variableWidth: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          adaptiveHeight: true,
        },
      },
    ],
  });
